import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _map from 'lodash/map';
import _noop from 'lodash/noop';
import _isFunction from 'lodash/isFunction';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import Icon, { SIZES } from '../../../../atoms/FontIcon';
// Constants
import actionTypes from '../../../TableManager/constants/actionTypes';
import { ASC, DESC } from '../../constants/inputTable.sort';

// Helpers
import { getHeaderPropsForColumn } from './inputTableHeader.helpers';

// Builders
import ColumnConfig from '../../builders/ColumnConfig';

// Styles
import s from './inputTableHeader.module.scss';
var DEFAULT_COLUMN_CONFIG = new ColumnConfig();

// TODO: Need to add dynamic styling via css
var InputTableHeader = /*#__PURE__*/function (_PureComponent) {
  _inherits(InputTableHeader, _PureComponent);
  var _super = _createSuper(InputTableHeader);
  function InputTableHeader() {
    var _this;
    _classCallCheck(this, InputTableHeader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "renderHeader", function () {
      var columnConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_COLUMN_CONFIG;
      var data = arguments.length > 1 ? arguments[1] : undefined;
      var header = columnConfig.getHeader();
      var headerProps = getHeaderPropsForColumn(columnConfig, data);
      if (_isFunction(header)) return header(headerProps);
      return header;
    });
    _defineProperty(_assertThisInitialized(_this), "renderHeaderCell", function () {
      var _cx;
      var columnConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_COLUMN_CONFIG;
      var _this$props = _this.props,
        sortDetails = _this$props.sortDetails,
        data = _this$props.data;
      var headerClassName = columnConfig.getHeaderClassName();
      var headerWidth = columnConfig.getWidth();
      var headerMinWidth = columnConfig.getMinWidth();
      var isSortable = columnConfig.sortable;
      var isRightAlign = columnConfig.isHeaderRightAlign;
      var sortType = sortDetails[columnConfig.id];
      var sortProps = isSortable ? {
        onClick: _this.handleSortUpdate(columnConfig)
      } : {};
      var headerStyle = {
        width: headerWidth,
        minWidth: headerMinWidth
      };
      var headerWrapperClassName = cx(headerClassName, s.headerCell, (_cx = {}, _defineProperty(_cx, s.headerCell__expand, !headerWidth), _defineProperty(_cx, s.headerContent__rightAlign, isRightAlign), _cx));
      var children = columnConfig.getChildren();
      var hasChildren = children === null || children === void 0 ? void 0 : children.length;
      return /*#__PURE__*/React.createElement("div", _extends({}, sortProps, {
        style: headerStyle,
        className: cx(headerWrapperClassName, _defineProperty({}, s.parentWrapperCell, hasChildren))
      }), !hasChildren ? /*#__PURE__*/React.createElement("div", {
        className: cx(_defineProperty({}, s.headerCell__sortable, isSortable))
      }, /*#__PURE__*/React.createElement("div", null, _this.renderHeader(columnConfig, data)), isSortable && /*#__PURE__*/React.createElement(Icon, {
        size: SIZES.S,
        className: cx(_defineProperty({
          'icon-arrow-down': sortType === DESC,
          'icon-arrow-up': sortType === ASC
        }, "".concat(s.sortIndicator, " icon-sort-by"), !sortType))
      })) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: headerStyle,
        className: headerWrapperClassName
      }, _this.renderHeader(columnConfig, data)), /*#__PURE__*/React.createElement("div", {
        className: "flex flex-row"
      }, _map(children, _this.renderHeaderCell))));
    });
    _defineProperty(_assertThisInitialized(_this), "setSortType", function (key) {
      var _this$props$sortDetai = _this.props.sortDetails,
        sortDetails = _this$props$sortDetai === void 0 ? EMPTY_OBJECT : _this$props$sortDetai;
      return _defineProperty({}, key, sortDetails[key] === DESC ? ASC : DESC);
    });
    _defineProperty(_assertThisInitialized(_this), "handleSortUpdate", function (columnConfig) {
      return function () {
        var onAction = _this.props.onAction;
        var id = columnConfig.id;
        var sortTypeMap = _this.setSortType(id);
        onAction({
          type: actionTypes.TABLE_ITEMS_SORT,
          payload: {
            value: {
              column: columnConfig,
              sortTypeMap: sortTypeMap
            }
          }
        });
      };
    });
    return _this;
  }
  _createClass(InputTableHeader, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        columns = _this$props2.columns,
        headerClassName = _this$props2.headerClassName;
      return /*#__PURE__*/React.createElement("div", {
        className: "flex ".concat(s.header, " ").concat(headerClassName)
      }, _map(columns, this.renderHeaderCell));
    }
  }]);
  return InputTableHeader;
}(PureComponent);
InputTableHeader.propTypes = {
  columns: PropTypes.array,
  sortDetails: PropTypes.object,
  onAction: PropTypes.func,
  headerClassName: PropTypes.string,
  data: PropTypes.array
};
InputTableHeader.defaultProps = {
  columns: EMPTY_ARRAY,
  sortDetails: EMPTY_OBJECT,
  onAction: _noop,
  headerClassName: '',
  data: EMPTY_ARRAY
};
export default InputTableHeader;